import { urlConfig } from 'config/url.config'
import { memo } from 'react'
import { Navigate } from 'react-router-dom'

interface IndexPageProps {}
export const IndexPage: React.FC<IndexPageProps> = memo(() => {
    return <Navigate to={urlConfig.pages.main} replace />
})
IndexPage.displayName = IndexPage.name
